export const ThirdPartyAppStatus = {
	review: 10,
	published: 20,
	rejected: 30,
};

export const ThirdPartyAppStatusColors = {
	[ThirdPartyAppStatus.review]: "#d6ebf7", // light blue
	[ThirdPartyAppStatus.published]: "#d4edda", // light green
	[ThirdPartyAppStatus.rejected]: "#f8d7da", // light red
};



export const ThirdPartyAppStatusName = Object.fromEntries(
	Object.entries(ThirdPartyAppStatus).map(([name, value]) => [value, name])
);
